import {
  CREATE_ANNOUNCEMENT_FAILURE,
  CREATE_ANNOUNCEMENT_REQUEST,
  CREATE_ANNOUNCEMENT_SUCCESS,
  DELETE_ANNOUNCEMENT_FAILURE,
  DELETE_ANNOUNCEMENT_REQUEST,
  DELETE_ANNOUNCEMENT_SUCCESS,
  GET_ANNOUNCEMENTS_FAILURE,
  GET_ANNOUNCEMENTS_REQUEST,
  GET_ANNOUNCEMENTS_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  SEND_ANNOUNCEMENT_FAILURE,
  SEND_ANNOUNCEMENT_REQUEST,
  SEND_ANNOUNCEMENT_SUCCESS,
  UPDATE_ANNOUNCEMENT_FAILURE,
  UPDATE_ANNOUNCEMENT_REQUEST,
  UPDATE_ANNOUNCEMENT_SUCCESS,
} from '../../actionConstants';

import apiClient from '../../apiClient';

export const getAnnouncements = (dispatch, queryParams, isExport) =>
  dispatch({
    type: GET_ANNOUNCEMENTS_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.announcements.getList(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_ANNOUNCEMENTS_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        dispatch({
          type: GET_ANNOUNCEMENTS_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const createAnnouncement = (dispatch, data) =>
  dispatch({
    type: CREATE_ANNOUNCEMENT_REQUEST,
    payload: apiClient.announcements.create(data).then(
      (res) => {
        dispatch({
          type: CREATE_ANNOUNCEMENT_SUCCESS,
          successMessage: 'Announcement saved',
          res,
        });
        return res;
      },
      (err) => {
        dispatch({
          type: CREATE_ANNOUNCEMENT_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const updateAnnouncement = (dispatch, id, data) =>
  dispatch({
    type: UPDATE_ANNOUNCEMENT_REQUEST,
    payload: apiClient.announcements.update(id, data).then(
      (res) => {
        dispatch({
          type: UPDATE_ANNOUNCEMENT_SUCCESS,
          successMessage: 'Announcement updated',
          res,
        });
        return res;
      },
      (err) => {
        dispatch({
          type: UPDATE_ANNOUNCEMENT_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const deleteAnnouncement = (dispatch, id) =>
  dispatch({
    type: DELETE_ANNOUNCEMENT_REQUEST,
    payload: apiClient.announcements.delete(id).then(
      (res) => {
        dispatch({
          type: DELETE_ANNOUNCEMENT_SUCCESS,
          successMessage: 'Announcement deleted',
          res,
        });
        return res;
      },
      (err) => {
        dispatch({
          type: DELETE_ANNOUNCEMENT_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const sendAnnouncement = (dispatch, id) =>
  dispatch({
    type: SEND_ANNOUNCEMENT_REQUEST,
    payload: apiClient.announcements.send(id).then(
      (res) => {
        dispatch({
          type: SEND_ANNOUNCEMENT_SUCCESS,
          successMessage: 'Announcement sent',
          res,
        });
        return res;
      },
      (err) => {
        dispatch({
          type: SEND_ANNOUNCEMENT_FAILURE,
          err,
        });
        return err;
      },
    ),
  });
